import { createContext, Dispatch, PropsWithChildren, SetStateAction, useState } from 'react'

export interface LoadingContextProps {
  loading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
}

export const LoadingContext = createContext({} as LoadingContextProps)

export const LoadingProvider = ({ children }: PropsWithChildren) => {
  const [loading, setLoading] = useState<LoadingContextProps['loading']>(false)

  const value = {
    loading,
    setLoading
  }

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
}
